import React from "react";
import { Link } from "react-router-dom";
import "../service.css";
import "./onboardStyle.css";

export const Onboard = () => {
  return (
    <>
      {/* Hero Section */}
      <div>
        <div className="tj-inner-banner">
          <div className="container">
            <h2>Safety Onboard</h2>
          </div>
        </div>

        <div className="tj-breadcrumb">
          <div className="container">
            <ul className="breadcrumb-list">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li className="active">Safety Onboard</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="onboard-container container">
        <div style={{ padding: "30px", display: "flex" }}></div>
        <div className="">
          {/* Main Heading */}
          <div className="onboard-heading-section">
            <h1 className="onboard-main-heading">
              Carpooling Safety Policy (Private Vehicle Sharing)
            </h1>
            <div className="onboard-intro">
              <p>
                At FareX, we promote responsible and safe ride-sharing between
                individuals through our carpooling platform. While these rides
                are conducted in private vehicles by everyday users, we provide
                essential tools and guidelines to ensure a smooth, respectful,
                and secure travel experience for all.
              </p>
            </div>
          </div>

          {/* What We Provide Section */}
          <section className="onboard-section">
            <h2 className="section-title">What We Provide</h2>
            <div className="features-grid">
              <div className="feature-card">
                <div className="feature-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M12 3c-4.962 0-9 4.038-9 9 0 4.963 4.038 9 9 9 4.963 0 9-4.037 9-9 0-4.962-4.037-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7zm1-11h-2v6h6v-2h-4z" />
                  </svg>
                </div>
                <h3 className="feature-title">Verified User Accounts</h3>
                <p className="feature-description">
                  All users must register with a valid phone number, email ID,
                  and personal details. We promote transparency with public
                  profiles and rider history.
                </p>
              </div>

              <div className="feature-card">
                <div className="feature-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                  </svg>
                </div>
                <h3 className="feature-title">Track Your Ride</h3>
                <p className="feature-description">
                  Riders and co-passengers can access live ride tracking through
                  the FareX app to share their location with friends or family.
                </p>
              </div>

              <div className="feature-card">
                <div className="feature-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                  </svg>
                </div>
                <h3 className="feature-title">Ratings & Reviews</h3>
                <p className="feature-description">
                  All users can rate their co-travelers, helping the community
                  maintain trust, safety, and accountability.
                </p>
              </div>
            </div>
          </section>

          {/* What We Encourage Section */}
          <section className="onboard-section onboard-encourage">
            <h2 className="section-title">What We Encourage</h2>
            <div className="encourage-list">
              <div className="encourage-item">
                <div className="check-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                  </svg>
                </div>
                <p>Respect each other's time, space, and comfort.</p>
              </div>
              <div className="encourage-item">
                <div className="check-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                  </svg>
                </div>
                <p>
                  Maintain basic etiquette throughout the ride (e.g., no
                  smoking, loud music, or inappropriate conversation).
                </p>
              </div>
              <div className="encourage-item">
                <div className="check-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                  </svg>
                </div>
                <p>
                  Avoid last-minute cancellations to ensure a smooth experience
                  for all.
                </p>
              </div>
              <div className="encourage-item">
                <div className="check-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                  </svg>
                </div>
                <p>Share emergency contacts when traveling long distances.</p>
              </div>
              <div className="encourage-item">
                <div className="check-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                  </svg>
                </div>
                <p>
                  Only board rides scheduled via the FareX platform—no
                  off-platform coordination.
                </p>
              </div>
            </div>
          </section>

          {/* Important Note */}
          <section className="onboard-section onboard-note">
            <div className="note-header">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
              </svg>
              <h3>Important Note</h3>
            </div>
            <div className="note-content">
              <p>
                FareX acts as a facilitator for carpooling. Since these rides
                are not operated by commercial drivers, we do not control the
                behavior or performance of individual drivers. However, we take
                every complaint seriously and may suspend or ban users who
                violate our safety guidelines or code of conduct.
              </p>
              <p>
                FareX Carpooling is built on mutual trust, community
                responsibility, and shared values. Let's keep the roads
                safe—together.
              </p>
            </div>
          </section>

          {/* Shared Cabs Section */}
          <section className="onboard-section onboard-shared">
            <h2 className="section-title">
              FareX Shared Cabs – Onboard Safety Policy
            </h2>
            <div className="shared-intro">
              <p>
                At FareX, we understand that trust and safety are
                essential—especially for long-distance, shared travel. That's
                why we've built FareX Shared Cabs not just as a ride-sharing
                service, but as a secure, dependable, and comfortable travel
                experience backed by professional standards.
              </p>
              <p>
                From verified drivers to strict scheduling protocols, every part
                of your journey is designed to ensure safety, reliability, and
                peace of mind.
              </p>
            </div>
          </section>

          {/* Safety Commitments */}
          <section className="onboard-section">
  <h2 className="section-title">Our Safety Commitments</h2>
  <div className="commitments-grid">
    {/* Card 1 */}
    <div className="commitment-card">
      <div className="commitment-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
        </svg>
      </div>
      <h3 className="commitment-title">Verified & Trained Drivers</h3>
      <p>
        Every FareX driver is background-checked, identity-verified,
        and trained in safe driving, customer handling, and emergency
        protocols.
      </p>
    </div>

    {/* Card 2 */}
    <div className="commitment-card">
      <div className="commitment-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <path d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.85 7h10.29l1.08 3.11H5.77L6.85 7zM19 17H5v-5h14v5z"/>
          <circle cx="7.5" cy="14.5" r="1.5"/>
          <circle cx="16.5" cy="14.5" r="1.5"/>
        </svg>
      </div>
      <h3 className="commitment-title">Licensed, Inspected Vehicles</h3>
      <p>
        All cabs used in FareX Shared Cabs are commercially registered
        and undergo regular maintenance checks to meet our ride
        quality standards.
      </p>
    </div>

    {/* Card 3 */}
    <div className="commitment-card">
      <div className="commitment-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
        </svg>
      </div>
      <h3 className="commitment-title">Guaranteed Departures, No Cancellations</h3>
      <p>
        Unlike traditional ride-sharing, we do not allow last-minute
        cancellations. Your ride is guaranteed once booked—no
        surprises, no delays.
      </p>
    </div>

    {/* Card 4 */}
    <div className="commitment-card">
      <div className="commitment-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
        </svg>
      </div>
      <h3 className="commitment-title">Real-Time GPS Tracking</h3>
      <p>
        Track your cab live through the app. You can share your ride
        status with friends or family for added reassurance.
      </p>
    </div>

    {/* Card 5 */}
    <div className="commitment-card">
      <div className="commitment-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v6h-2zm0 8h2v2h-2z"/>
        </svg>
      </div>
      <h3 className="commitment-title">Emergency Support</h3>
      <p>
        Our 24/7 customer support and in-app SOS button are always
        available to assist in case of an emergency.
      </p>
    </div>

    {/* Card 6 */}
    <div className="commitment-card">
      <div className="commitment-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4zM10 15l-3-3v2H4v2h3v2l3-3zm3.5-6L13 7v2H8v2h5v2l2.5-2.5z"/>
        </svg>
      </div>
      <h3 className="commitment-title">Secure Boarding Verification</h3>
      <p>
        At pickup, we confirm rider identity to ensure only verified
        passengers are allowed to board.
      </p>
    </div>

    {/* Card 7 */}
    <div className="commitment-card">
      <div className="commitment-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/>
        </svg>
      </div>
      <h3 className="commitment-title">Hygienic & Sanitized Travel</h3>
      <p>
        All cabs are routinely cleaned and sanitized for a safe,
        comfortable journey—especially on long intercity routes.
      </p>
    </div>
  </div>
</section>

          {/* Passenger Guidelines */}
          <section className="onboard-section onboard-guidelines">
            <div className="guidelines-header">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
              </svg>
              <h3>Passenger Safety Guidelines</h3>
            </div>
            <div className="guidelines-list">
              <div className="guideline-item">
                <div className="bullet"></div>
                <p>Be ready on time for your scheduled departure.</p>
              </div>
              <div className="guideline-item">
                <div className="bullet"></div>
                <p>Carry a valid photo ID for boarding verification.</p>
              </div>
              <div className="guideline-item">
                <div className="bullet"></div>
                <p>Wear your seatbelt at all times.</p>
              </div>
              <div className="guideline-item">
                <div className="bullet"></div>
                <p>
                  Report any concerns to the driver or through the FareX app
                  immediately.
                </p>
              </div>
              <div className="guideline-item">
                <div className="bullet"></div>
                <p>Respect your co-passengers—our rides are a shared space.</p>
              </div>
            </div>
          </section>

          {/* Final Section */}
          <section className="onboard-section onboard-final">
            <h3 className="final-title">
              Why Safety at FareX Isn't an Add-On—It's a Standard
            </h3>
            <div className="final-content">
              <p>
                FareX Shared Cabs was built to offer all the benefits of
                carpooling—affordability, environmental impact, social
                connectivity—without compromising on professionalism,
                punctuality, or safety.
              </p>
              <p className="highlight">
                With FareX, you don't just share a ride.
                <br />
                You share a reliable, secure, and premium travel experience.
              </p>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};
